import { Box } from "@mui/material";
import ProfileCard from "./ProfileCard";
import ExperienceStats from "./ExperienceStats";
import GeneralInfo from "./GeneralInfo";
import SocialMedia from "./SocialMedia";

const ProfileSidebar = ({ user, profile }) => {
  return (
    <Box className="profile-sidebar">
      <ProfileCard user={user} profile={profile} />
      <ExperienceStats user={user} profile={profile} />
      <GeneralInfo user={user} profile={profile} />
      <SocialMedia profile={profile} />
    </Box>
  );
};

export default ProfileSidebar;
